import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { CardGroup } from "react-bootstrap";
import { useSelector } from "react-redux";
import { selectInGouvernanceFilters } from "../../../redux/ReduxFilter";
import ComponentSousTitle from "../../layout/ComponentSousTitle";
import ComponentEspace from "../colidee/ComponentEspace";
import ComponentGovernanceChrono from "./ComponentGovernanceChrono";

const ComponentGovernanceViewFriseChrono = (props) => {
  const { orgunitsRituel, orgunitsTempsCollectif, espaces, anteriorite } = props;
  const { t } = useTranslation();
  const [objectHebdomadaire, setObjectHebdomadaire] = useState([]);
  const [objectMensuel, setObjectMensuel] = useState([]);
  const [objectAnnuel, setObjectAnnuel] = useState([]);
  const [espaceOrder, setEspaceOrder] = useState([]);
  const _selectInGouvernanceFilters = useSelector(selectInGouvernanceFilters);

  const ordonneDatas = () => {
    // on calcule la date UNIX du jour
    var now = new Date();
    // on calcule la date UNIX 30 jours avant
    var nomMoinsAnteriorite = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate() - anteriorite
    );

    // on mt en forme la date du jour au format AAAA-MM-JJ pour pouvoir la comparer par la suite
    var dateDuJour =
      now.getFullYear() +
      "-" +
      ("0" + (now.getMonth() + 1)).slice(-2) +
      "-" +
      ("0" + now.getDate()).slice(-2);
    // on mt en forme la date 30 jours avant au format AAAA-MM-JJ pour pouvoir la comparer par la suite
    var dateMoisDernier =
      nomMoinsAnteriorite.getFullYear() +
      "-" +
      ("0" + (nomMoinsAnteriorite.getMonth() + 1)).slice(-2) +
      "-" +
      ("0" + nomMoinsAnteriorite.getDate()).slice(-2);

    // on initialise un objet qui aura pour clé la date de du rituel pour ensuite pouvoir les trier
    const tabObjectHebdomadaire = [];
    const tabObjectMensuel = [];
    const tabObjectAnnuel = [];
    const espaceOrderTemp = [];

    // on parcours les espaces en comparant si la date de contrib tombe entre la date du jour et celle d'il y a 30 jours
    // si c'est le cas on pousse dans l'objet objectOrderTemp

    espaces.forEach((element) => {
      element.typeObjectCalendar = "espace";
      let dateComparee = element.dateDerniereContrib.split(" ")[0];
      if (dateComparee >= dateMoisDernier && dateComparee <= dateDuJour) {
        let elementCopy = { ...element };
        elementCopy.dateObjectCalendar = dateComparee;
        espaceOrderTemp.push(elementCopy);
      }
    });

    // on parcours les orgunits en comparant si la date de RDV tombe entre la date du jour et celle d'il y a 30 jours
    // si c'est le cas on pousse dans l'objet objectOrderTemp
    let orgunitsMerge = [];
    if (_selectInGouvernanceFilters.rituel || _selectInGouvernanceFilters.all)
      orgunitsMerge = orgunitsMerge.concat(orgunitsRituel);
    if (_selectInGouvernanceFilters.tempscollectif || _selectInGouvernanceFilters.all)
      orgunitsMerge = orgunitsMerge.concat(orgunitsTempsCollectif);

    orgunitsMerge.forEach((element) => {
      if (element.detailFrequence.length) {
        if (element.type === "Rituel") {
          element.typeObjectCalendar = "orgunitRituel";
        }
        if (element.type === "Temps collectif") {
          element.typeObjectCalendar = "orgunitTempscollectif";
        }
        if (element.frequence === "Hebdomadaire") {
          tabObjectHebdomadaire.push(element);
        }
        if (element.frequence === "Mensuel") {
          tabObjectMensuel.push(element);
        }
        if (element.frequence === "Annuel") {
          tabObjectAnnuel.push(element);
        }
      }
    });

    espaceOrderTemp.sort((b, a) =>
      a.dateObjectCalendar > b.dateObjectCalendar
        ? 1
        : b.dateObjectCalendar > a.dateObjectCalendar
        ? -1
        : 0
    );

    setEspaceOrder(espaceOrderTemp);
    setObjectHebdomadaire(tabObjectHebdomadaire);
    setObjectMensuel(tabObjectMensuel);
    setObjectAnnuel(tabObjectAnnuel);
  };

  useEffect(() => {
    ordonneDatas();
  }, [anteriorite, _selectInGouvernanceFilters]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div>
      {(_selectInGouvernanceFilters.espace || _selectInGouvernanceFilters.all) && (
        <>
          <h4 className="mt-4">{t("public.componentOrgUnit.frequenceInstantaneeAdverbe")}</h4>
          <CardGroup className="mb-5 chronoConcertation">
            {espaceOrder.map((item, index) => (
              <ComponentEspace espaceObject={item} key={index} />
            ))}
            {espaceOrder.length === 0 && <>{t("public.pageInGovernance.aucuneConcertation")}</>}
          </CardGroup>
        </>
      )}

      {(_selectInGouvernanceFilters.rituel ||
        _selectInGouvernanceFilters.tempscollectif ||
        _selectInGouvernanceFilters.all) && (
        <>
          <h4 className="mt-4">{t("public.componentOrgUnit.frequenceHebdomadaireAdverbe")}</h4>
          {objectHebdomadaire.length === 0 && (
            <div className="mb-5">{t("public.pageInGovernance.aucunRituelTemps")}</div>
          )}
          {objectHebdomadaire.length > 0 && (
            <ComponentGovernanceChrono objets={objectHebdomadaire} temporalite="hebdomadaire" />
          )}

          <h4>{t("public.componentOrgUnit.frequenceMensuelAdverbe")}</h4>
          {objectMensuel.length === 0 && (
            <div className="mb-5">{t("public.pageInGovernance.aucunRituelTemps")}</div>
          )}
          {objectMensuel.length > 0 && (
            <ComponentGovernanceChrono objets={objectMensuel} temporalite="mensuel" />
          )}

          <h4>{t("public.componentOrgUnit.frequenceAnnuelAdverbe")}</h4>
          {objectAnnuel.length === 0 && (
            <div className="mb-5">{t("public.pageInGovernance.aucunRituelTemps")}</div>
          )}
          {objectAnnuel.length > 0 && (
            <ComponentGovernanceChrono objets={objectAnnuel} temporalite="annuel" />
          )}
        </>
      )}
      <br />
      <br />
      <br />
      <br />
    </div>
  );
};

export default ComponentGovernanceViewFriseChrono;
